import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Menu } from '../../models/menu.model';
import { Subscription } from 'rxjs/Subscription';
import { AdminService } from '../admin.service';
import { ActivatedRoute, Router } from '@angular/router';

import { Slug } from 'ng2-slugify';
import { MalihuScrollbarModule, MalihuScrollbarService } from 'ngx-malihu-scrollbar';

import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
  group
} from '@angular/animations';

@Component({
  selector: 'app-sidebar-admin',
  templateUrl: './sidebar-admin.component.html',
  styleUrls: ['./sidebar-admin.component.css']
})
export class SidebarAdminComponent implements OnInit, AfterViewInit, OnDestroy {
  subscription1: Subscription;
  menus: Menu[];
  currentRoute: ActivatedRoute;
  defaultSubMenu = '';
  menuType = '';
  urlFragment = '';

  @ViewChild('sidebarBox') sidebarBox: ElementRef;
  @ViewChild('sidebarSubBox') sidebarSubBox: ElementRef;

  slug = new Slug(null);

  constructor(private adminService: AdminService,
              private route: ActivatedRoute,
              private router: Router,
              private mScrollbarService: MalihuScrollbarService) { }

  ngOnInit() {
    this.subscription1 = this.adminService.menuChanged.subscribe(
      (menus: Menu[]) => {
        this.menus = menus;

        if (!this.adminService.hasMenu()) {
          this.sidebarBox.nativeElement.className = 'col-xs-12 col-sm-12 col-md-12 height-100';
          this.sidebarSubBox.nativeElement.className = 'hidden';
        } else {
          this.sidebarBox.nativeElement.className = 'col-xs-4 col-sm-4 col-md-6 height-100';
          this.sidebarSubBox.nativeElement.className = 'col-xs-8 col-sm-8 col-md-6 height-100';
        }
      }
    );

    this.adminService.routeData.subscribe(
      (data: any) => {
        this.currentRoute = data.route;
        this.urlFragment = '';
        this.defaultSubMenu = data.default;
        this.menuType = data.type;
      }
    );
  }

  nagivateLink(url) {
    this.router.navigate([], {relativeTo: this.currentRoute, fragment: url});
    this.urlFragment = url;
  }

  slugLink(link: string) {
    return this.slug.slugify((link).trim());
  }

  ngAfterViewInit() {
    this.mScrollbarService.initScrollbar('#malihusb', { axis: 'y', theme: 'minimal', scrollInertia: 600 });
  }

  ngOnDestroy() {
    this.subscription1.unsubscribe();
    this.mScrollbarService.destroy('#malihusb');
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/sidebar-admin/sidebar-admin.component.ts